/* ==========================================================================
   SearcherPackagesFerry > Client > Button
   ========================================================================== */

/* Modules */
const ButtonClient = require('@bluekiri/alexandria-contrib-components/components/button/client/js');
const validations = require('../../../../helpers/validations');

/* Init */
function initButton(selector, instance, configuration) {
    document.querySelector(selector).addEventListener('click', () => validate(instance, configuration));

    return ButtonClient(selector, configuration);
}

function validate(instance, configuration) {
    const validationResult = validations.validateFields(instance);

    if (!validationResult.success) {
        return;
    }

    const params = buildParams(instance);

    if (!validateHandleEndpoint(instance, params)) {
        return;
    }

    const urlParams = paramsDictToUrl(params);

    if (validationResult.success) {
        const url = instance.element.dataset.submiturl || configuration.url;
        window.location.assign(`${url}?${urlParams}`);
    } else {
        validationResult.fieldsError.forEach(field => field.setError());
    }

    // Modal Loading
    instance.loading.setContentTemplate(instance);
    instance.loading.modal.start();
}

function validateHandleEndpoint(instance, params) {
    if (!instance.config.endpoint) {
        return true;
    }

    const paramsRef = params;
    const [destinationPort, destinationType, destinationCode, withCar] = instance.location[1].value
        ? instance.location[1].value.toString().split(',')
        : false;

    if (withCar && withCar === 'true' && instance.vehicle.panel.vehicle.vehicle.product.value === '0') {
        instance.vehicle.trigger.setError();

        return false;
    }

    paramsRef.PuertoDestinoFER = destinationPort;
    paramsRef.destinationType = destinationType;
    paramsRef.destinationCode = destinationCode;

    return true;
}

function buildParams(instance) {
    const params = {
        PuertoOrigenFER: instance.location[0].value,
        PuertoDestinoFER: instance.location[1].value,
        fechaIdaFER: dateFormat(instance.calendar.fp.selectedDates[0]),
        fechaVueltaFER: dateFormat(instance.calendar.fp.selectedDates[1]),
        roomPax: countPaxes(instance),
        tipoVehiculoFER: instance.vehicle.panel.vehicle.vehicle.product.value,
        alturaVehiculoFER: instance.vehicle.panel.vehicle.vehicle.height.value,
        longitudVehiculoFER: instance.vehicle.panel.vehicle.vehicle.length.value,
        tipoRemolqueFER: instance.vehicle.panel.vehicle.extra.toggle.isChecked() ? 1 : 0,
        alturaRemolqueFER: instance.vehicle.panel.vehicle.extra.height.value,
        longitudRemolqueFER: instance.vehicle.panel.vehicle.extra.length.value,
        tipoResidenteFER: instance.passenger.panelAccommodation.accommodation.resident
            ? instance.passenger.panelAccommodation.accommodation.resident.value
            : 0,
        tipoDescuentoFER: instance.passenger.panelAccommodation.accommodation.bonuses
            ? instance.passenger.panelAccommodation.accommodation.bonuses.value
            : 0,
        edad1: getRoomPaxes(instance, 0),
        edad2: getRoomPaxes(instance, 1),
        edad3: getRoomPaxes(instance, 2),
        edad4: getRoomPaxes(instance, 3),
        listaPaxEdadesFER: getAllRoomPaxes(instance),
        soloIdaFER: 0,
        numPaxFER: countPaxes(instance),
        ProductType: 'FerryHotel',
        hotelCode: instance.config.hotelCode || ''
    };

    const hotelChainData = instance.element.getAttribute('data-hotel-chain') || '';
    if (hotelChainData) params.hotelChain = hotelChainData;

    return params;
}

function getHashRoom(instance) {
    return instance.passenger.panelAccommodation.accommodation.getHashRoom().replace(/[AC]/g, '%23');
}

function getRoomPaxArray(instance) {
    return getHashRoom(instance).split(',');
}

function getRoomPaxes(instance, index) {
    const array = getRoomPaxArray(instance);
    const paxes = array[index];
    return paxes !== undefined ? paxes : '';
}

function getAllRoomPaxes(instance) {
    return getHashRoom(instance).replace(/,/g, '');
}

function countPaxes(instance) {
    return getAllRoomPaxes(instance).split('%23').length - 1;
}

function dateFormat(date) {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

function paramsDictToUrl(params) {
    const arrParams = [];

    Object.keys(params).forEach(key => {
        arrParams.push(`${key}=${params[key]}`);
    });

    return arrParams.join('&');
}

module.exports = {
    initButton
};
